import { useState, useEffect } from 'react';
import { Shield, Shirt } from 'lucide-react';

export default function AnimatedLogo({ className = "w-8 h-8" }) {
  const [showShield, setShowShield] = useState(false); // Start with t-shirt
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      
      // After fade out, switch icon
      setTimeout(() => {
        setShowShield(prev => !prev);
        setIsTransitioning(false);
      }, 500); // Half of transition time
      
    }, 10000); // Every 10 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`relative ${className}`}>
      {/* Shield Icon */}
      <Shield 
        className={`absolute inset-0 w-full h-full text-[#D4AF37] transition-all duration-500 ${
          showShield && !isTransitioning 
            ? 'opacity-100 scale-100 rotate-0' 
            : 'opacity-0 scale-75 -rotate-12'
        }`}
      />
      
      {/* T-Shirt Icon */}
      <Shirt 
        className={`absolute inset-0 w-full h-full text-[#D4AF37] transition-all duration-500 ${
          !showShield && !isTransitioning 
            ? 'opacity-100 scale-100 rotate-0' 
            : 'opacity-0 scale-75 rotate-12'
        }`}
      />
    </div>
  );
}
